import React, { useState, useRef } from 'react';

import { Col, Divider, Modal, Row } from 'antd';

import MyButton from './Button';

import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import { useReactToPrint } from 'react-to-print';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { ASSET_BASE_PATH } from '../constants/Config';
import _ from 'lodash';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect } from 'react';
import GetProfile from './VariableStore';
import { FormattedMessage } from 'react-intl';
import './style/preview.css';
import PrintLabel from './PrintLabel';

// import { useState } from "react";

const ShipmentPreviewModal = (props) => {
  const { isOpen, onCancle,info,parcels } = props;
  const isDesktop = useIsDesktop();
  const [zipcode, setZipcode] = useState([]);
  const componentRef = useRef();
  const numberZipcode = [1, 2, 3, 4, 5];

  const address = _.get(info, 'destination.address') || '';
  const postalCodePattern = /\b\d{5}\b/;
  const postalCodeMatch = address.match(postalCodePattern);
  const postalCode = postalCodeMatch ? postalCodeMatch[0] : '00000';
  const phone = GetProfile('phone');
  // const parcel = [_.get(info, 'parcel')];



  // Create Document Component

  useEffect(() => {
    const words = _.slice(address, -5);
    const extractedNumbers = _.map(postalCode, (e) => getNumbersFromString(e));



    setZipcode(extractedNumbers);


  }, [isOpen]);

  const getNumbersFromString = (str) => {
    const numbers = str.match(/\d+/g); // Regular expression to match one or more digits
    return numbers ? numbers.map(Number) : [];
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'data',
    copyStyles: true,
  });


  return (
    <Modal
      title={
        <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
          <FormattedMessage id='btnPrintTransportWaybill' defaultMessage='Print Transport Waybill' />
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      width={680}
      maskClosable={false}
      centered={isDesktop ? true : false}
      footer={[
        isDesktop ? (
          <>
            <MyButton
              onClick={() => {
                onCancle();
              }}
              style={{
                width: isDesktop ? '20%' : '48%',
                marginRight: '10px',
              }}
            >
              <FormattedMessage id='btnClose' defaultMessage='Close' />
            </MyButton>
            <MyButton
              isPrimary
              onClick={() => {
                handlePrint();
              }}
              style={{
                width: isDesktop ? '20%' : '48%',
              }}
            >
              <FormattedMessage id='btnPrint' defaultMessage='Print' />
            </MyButton>
          </>
        ) : (
          <>
            <MyButton
              isPrimary
              onClick={() => {
                handlePrint();
              }}
              style={{
                width: isDesktop ? 'auto' : '100%',
                marginBottom: '10px',
                marginTop: '-10px',
              }}
            >
              <FormattedMessage id='btnPrint' defaultMessage='Print' />
            </MyButton>

            <MyButton
              onClick={() => {
                onCancle();
              }}
              style={{
                width: isDesktop ? 'auto' : '100%',
                marginLeft: '0px',
              }}
            >
              <FormattedMessage id='btnClose' defaultMessage='Close' />
            </MyButton>
          </>
        ),
      ]}
    >
      <Divider className='m-0' />

      <div class='overpage' style={{ display: isDesktop ? 'flex' : null, justifyContent: 'center', alignItems: 'center',fontFamily: "openSans-Regular" }}>
        <div>
          {_.map(parcels, (parcelNo, index) => {
            return (
              <div
                className='mainpage'
                style={{
                  backgroundColor: '#FFF',
                  width: isDesktop ? '150mm' : null,
                  height: isDesktop ? '100mm' : null,
                  padding: '18px',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '5px',
                  }}
                >
                  <img src={`${ASSET_BASE_PATH}/assets/loop.png`} height={isDesktop ? 40 : 40} width={isDesktop ? 70 : 60} style={{ margin: 0 }} />
                  <img
                    src={`${ASSET_BASE_PATH}/assets/loopContact2.png`}
                    height={isDesktop ? 50 : 30}
                    width={isDesktop ? 180 : 110}
                    style={{ margin: 0 }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: '#fff',
                    height: '89%',
                    width: isDesktop ? '100%' : '100%',
                    border: isDesktop ? 'solid 3px' : 'solid 2.3px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div className='heightCom' style={{ height: isDesktop ? '100px' : null }}>
                    <div
                      style={{
                        fontSize: isDesktop ? '18px' : '14px',
                        paddingLeft: isDesktop ? '1vw' : '2vw',
                        paddingRight: '10%',
                        paddingTop: '3%',
                        fontWeight: 'bold',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>ผู้ส่ง : {_.get(info, 'customer.comtomerName')}</span>
                      <span style={{ marginLeft: isDesktop ? '2.5vw' : '1vw' }}>{phone}</span>
                    </div>
                    <div
                      className='address'
                      style={{
                        padding: '10px 3% 0px 3%',
                        fontWeight: 'bold',
                        fontSize: isDesktop ? '14px' : '8px',
                        height: '55px',
                        overflowY: 'hidden',
                      }}
                    >
                      {_.get(info, 'source.address')}
                    </div>
                    <hr
                      style={{
                        border: isDesktop ? 'solid 2px' : 'solid 1.2px',
                        marginTop: isDesktop ? '' : '',
                        marginBottom: isDesktop ? '' : '0px',
                      }}
                    />
                  </div>
                  <div className='heightCom' style={{ height: isDesktop ? '98px' : null }}>
                    <div
                      style={{
                        fontSize: isDesktop ? '18px' : '14px', // 3% of viewport width
                        paddingLeft: isDesktop ? '1vw' : '1vw', // Adjust padding based on device
                        paddingRight: '10%',
                        fontWeight: 'bold',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingTop: isDesktop ? '20px' : '3%',
                      }}
                    >
                      <span>ผู้รับ : {_.get(info, 'contact.customerContactName')}</span>
                      <span style={{ marginLeft: isDesktop ? '2.5vw' : '1vw' }}>{_.get(info, 'contact.customerContactPhone')}</span>
                    </div>
                    <div
                      class='address'
                      style={{
                        paddingLeft: '3%',
                        paddingBottom: isDesktop ? '10px' : '5px',
                        paddingTop: '10px',
                        fontWeight: 'bold',
                        height: '55px',
                        overflowY: 'hidden',
                        fontSize: isDesktop ? '14px' : '2vw',
                      }}
                    >
                      {_.get(info, 'destination.address')}
                    </div>
                  </div>

                  <div className='heightQr' style={{ height: isDesktop ? '80px' : null }}>
                    <Row style={{ height: '100%' }} justify={'center'} align={'center'}>
                      <Col span={isDesktop ? 18 : 17}>
                        <div
                          className='divZip'
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginLeft: isDesktop ? '3%' : '3%',
                            marginRight: isDesktop ? '5%' : '5%',
                            marginTop: isDesktop ? '15px' : '15px',
                          }}
                        >
                          {_.map(numberZipcode, (number, index) => {
                            return (
                              <Row key={number}>
                                <Col>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      backgroundColor: '#fff',
                                      height: isDesktop ? '65px' : '35px',
                                      width: isDesktop ? '45px' : '25px',
                                      marginLeft: '8px',
                                      textAlign: 'center',
                                      fontSize: isDesktop ? '36px' : '26px',
                                      fontWeight: 'bold',
                                      border: isDesktop ? 'solid 2px' : 'solid 2px',
                                    }}
                                  >
                                    {zipcode[index]}
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      </Col>
                      <Col span={isDesktop ? 6 : 7}>
                        <hr
                          style={{
                            border: isDesktop ? 'solid 2px' : 'solid 1.2px',
                            marginTop: isDesktop ? '1.5%' : '1.5%',
                            marginBottom: '0px',
                            marginLeft: isDesktop ? '5px' : undefined,
                          }}
                        />
                        <div
                          style={{
                            height: isDesktop ? '99%' : undefined,
                            width: isDesktop ? '100%' : '100%',
                            borderLeft: isDesktop ? 'solid 3px' : 'solid 2px',
                            marginBottom: '0px',
                            marginLeft: isDesktop ? '5px' : undefined,
                          }}
                        >
                          <div
                            className='subpage'
                            style={{
                              fontSize: isDesktop ? '12px' : '12px',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              paddingTop: '1%',
                            }}
                          >
                            Parcel No.
                            <div style={{ textAlign: 'center' }}>
                              <QRCodeSVG
                                class='qrcode'
                                style={{ marginTop: '0px', marginBottom: '0px', width: '70px', height: '50px' }}
                                value={_.get(parcelNo, 'parcelNo')}
                              />
                            </div>
                            <div style={{ fontWeight: 'bold',fontSize: isDesktop ? '10px' : '6.5px' }}>
                            {_.get(parcelNo, 'parcelNo')}
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ display: 'none' }}>
        <PrintLabel ref={componentRef} parcel={parcels} info={info} phone={phone} zipcode={zipcode} isDesktop={isDesktop} />
      </div>
    </Modal>
  );
};

export default ShipmentPreviewModal;
